import React from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";
import CustomInput from "../../../custom/CustomInput";
import CustomSelect from "../../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import CircularLoading from "../../loader/CircularIndeterminate";
import * as actions from "../../../redux/creators";
import Ajivasan_Uthsav from "../../../assets/AjivasanUtsav.pdf";
const AjivasanUtsav = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    let course_id = "";
    if (values.plan === "Gold") {
      course_id = "657";
    } else if (values.plan === "Silver") {
      course_id = "658";
    }

    const coursereg = {
      course_id,
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      age: values.age || "0",
      totalfees: values.totalfees,
      is_enquiry: "0",
      is_online_payment: "1",
    };

    // Direct backend redirect - iOS compatible
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
  };

  return (
    <Container>
      <div className="bg-white">
        <Row>
          <h5 className="text-center p-3">Please fill the form to register.</h5>
        </Row>
        <Card>
          <CardBody>
            <Formik
              initialValues={{
                clientname: "",
                clientemail: "",
                clientphone: "",
                age: "",
                plan: "",
                totalfees: "0",
                is_online_payment: "1",
                checked: false,
                // course_id: "657",
              }}
              validationSchema={Yup.object().shape({
                clientname: Yup.string().required("Required"),
                clientemail: Yup.string()
                  .required("Required")
                  .email("Invalid Email"),
                clientphone: Yup.string().required("Required"),
                plan: Yup.string()
                  .oneOf(["Gold", "Silver"], "Invalid plan")
                  .required("Select a plan"),
                checked: Yup.boolean().oneOf(
                  [true],
                  "You must accept the Terms & Conditions"
                ),
              })}
              onSubmit={handleSubmit}
            >
              {(formProps) => {
                // Update price when plan changes
                if (formProps.values.plan === "Gold") {
                  formProps.values.totalfees = 4900;
                } else if (formProps.values.plan === "Silver") {
                  formProps.values.totalfees = 2100;
                } else {
                  formProps.values.totalfees = 0;
                }

                return (
                  <Form className="mt-3">
                    {/* Name */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientname" className="label">
                          Your Full Name:
                        </Label>
                        <Field
                          component={CustomInput}
                          type="text"
                          name="clientname"
                          placeholder="Enter Your Name"
                          className={
                            "form-control" +
                            (formProps.errors.clientname &&
                            formProps.touched.clientname
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="clientname"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </Row>

                    {/* Age */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="age" className="label">
                          Age:
                        </Label>
                        <Field
                          component={CustomInput}
                          type="text"
                          name="age"
                          placeholder="Enter Your Age"
                          className={
                            "form-control" +
                            (formProps.errors.age && formProps.touched.age
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="age"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </Row>

                    {/* Email */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientemail" className="label">
                          Your Email:
                        </Label>
                        <Field
                          component={CustomInput}
                          type="text"
                          name="clientemail"
                          placeholder="Enter Your Email"
                          className={
                            "form-control" +
                            (formProps.errors.clientemail &&
                            formProps.touched.clientemail
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="clientemail"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </Row>

                    {/* Phone */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientphone" className="label">
                          Your Phone Number:
                        </Label>
                        <Field
                          component={CustomInput}
                          type="text"
                          name="clientphone"
                          placeholder="Enter Your Phone"
                          className={
                            "form-control" +
                            (formProps.errors.clientphone &&
                            formProps.touched.clientphone
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="clientphone"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </Row>

                    {/* Plan */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="plan" className="label">
                          Select Plan:
                        </Label>
                        <Field
                          component={CustomSelect}
                          name="plan"
                          className={
                            "form-control" +
                            (formProps.errors.plan && formProps.touched.plan
                              ? " is-invalid"
                              : "")
                          }
                        >
                          <option value="">Select Plan</option>
                          <option value="Gold">Gold</option>
                          <option value="Silver">Silver</option>
                        </Field>
                        <ErrorMessage
                          name="plan"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </Row>

                    {/* Amount */}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="totalfees" className="label">
                          Total Amount:
                        </Label>
                        <Field
                          component={CustomInput}
                          type="text"
                          name="totalfees"
                          disabled
                          className="form-control"
                        />
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <div className="form-check">
                          <Field
                            type="checkbox"
                            name="checked"
                            className={`form-check-input ${
                              formProps.errors.checked &&
                              formProps.touched.checked
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <label className="form-check-label">
                            I accept&nbsp;
                            <a
                              href={Ajivasan_Uthsav}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Terms & Conditions
                            </a>
                          </label>
                          <ErrorMessage
                            name="checked"
                            component="div"
                            className="invalid-feedback d-block"
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Submit */}
                    <div className="mt-3 mb-3 row">
                      <div className="col-12">
                        <Button type="submit" className="register-btn" block>
                          {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                        </Button>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default AjivasanUtsav;
